var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", { attrs: { title: _vm.getPageTitle } }),
      _vm._v(" "),
      this.$route.meta.method == "create"
        ? _c("div", { staticClass: "grid-container" }, [
            _c("div", { staticClass: "grid-x" }, [
              _c("div", { staticClass: "cell medium-9 large-11" }, [
                _c("div", { staticClass: "callout warning text-center" }, [
                  _vm._v(_vm._s(_vm.$t("tours.create.status"))),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _c("v-action-buttons", {
                attrs: {
                  items: _vm.getActionButtons,
                  isDisabled: _vm.objectFormDisabled,
                },
                on: { actionClicked: _vm.onClickAction },
              }),
              _vm._v(" "),
              _c("v-form-message", {
                attrs: {
                  type: "error",
                  id: "form-error",
                  message: _vm.objectError,
                },
                on: { onClickAction: _vm.onClickDialogAction },
              }),
              _vm._v(" "),
              _c("v-form-message", {
                attrs: {
                  type: "success",
                  id: "form-success",
                  message: _vm.objectSuccess,
                },
                on: { onClickAction: _vm.onClickDialogAction },
              }),
              _vm._v(" "),
              _c("v-form-message", {
                attrs: {
                  type: "default",
                  message: _vm.objectRemoveConfirm,
                  autoCloseTimeout: 0,
                  showActionButtons: true,
                },
                on: { onClickAction: _vm.onClickDialogAction },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "box u-extra-medium-padding--bottom" }, [
                _c(
                  "div",
                  { staticClass: "grid-x grid-margin-x align-middle" },
                  [
                    _c("div", { staticClass: "cell medium-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.$v.object.kolonne.$error,
                          },
                        },
                        [
                          _c(
                            "label",
                            { attrs: { for: "form-field-kolonne" } },
                            [_vm._v(_vm._s(_vm.$t("tours.kolonne")))]
                          ),
                          _vm._v(" "),
                          _c("v-select-kolonne", {
                            attrs: {
                              id: "form-field-kolonne",
                              name: "kolonne",
                              placeholder: _vm.$t("select"),
                            },
                            model: {
                              value: _vm.object.kolonne,
                              callback: function ($$v) {
                                _vm.$set(_vm.object, "kolonne", $$v)
                              },
                              expression: "object.kolonne",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell medium-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.$v.object.startdate.$error,
                          },
                        },
                        [
                          _c("label", [_vm._v(_vm._s(_vm.$t("search.from")))]),
                          _vm._v(" "),
                          _c("v-datepicker", {
                            staticClass:
                              "form-control form-control--small form-control--date",
                            attrs: {
                              placeholder: _vm.$t("search.from"),
                              format:
                                _vm.$t("search.from") +
                                " " +
                                _vm.$helpers.dateFormat,
                              clearButton: true,
                              "monday-first": true,
                              "disabled-dates": _vm.$helpers.disabledDates,
                              language: _vm.de,
                            },
                            model: {
                              value: _vm.object.startdate,
                              callback: function ($$v) {
                                _vm.$set(_vm.object, "startdate", $$v)
                              },
                              expression: "object.startdate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell medium-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.$v.object.enddate.$error,
                          },
                        },
                        [
                          _c("label", [_vm._v(_vm._s(_vm.$t("search.till")))]),
                          _vm._v(" "),
                          _c("v-datepicker", {
                            staticClass:
                              "form-control form-control--small form-control--date",
                            attrs: {
                              placeholder: _vm.$t("search.till"),
                              format:
                                _vm.$t("search.till") +
                                " " +
                                _vm.$helpers.dateFormat,
                              clearButton: true,
                              "monday-first": true,
                              "disabled-dates": {
                                days: [6, 0],
                                to: new Date(_vm.object.startdate),
                              },
                              language: _vm.de,
                            },
                            model: {
                              value: _vm.object.enddate,
                              callback: function ($$v) {
                                _vm.$set(_vm.object, "enddate", $$v)
                              },
                              expression: "object.enddate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell medium-3" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          class: [_vm.searchActive ? "hollow" : ""],
                          staticStyle: { "margin-top": "9px" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.showSearch.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("tours.button.searchform")) +
                              "\n                "
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.searchActive,
                                  expression: "!searchActive",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("tours.button.searchform.open"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.searchActive,
                                  expression: "searchActive",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("tours.button.searchform.close"))
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "u-fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchActive,
                        expression: "searchActive",
                      },
                    ],
                  },
                  [
                    _c("div", { staticClass: "box" }, [
                      _c("div", { staticClass: "grid-x grid-margin-x" }, [
                        _c("div", { staticClass: "cell medium-1" }, [
                          _c("div", { staticClass: "c-circle-label" }, [
                            _c(
                              "span",
                              { staticClass: "c-circle-label__text" },
                              [_vm._v("1")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "cell medium-11" },
                          [
                            _c(
                              "h2",
                              { staticClass: "u-extra-small-margin--bottom" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("tours.headline.companysearch"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-accordion", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid-x grid-margin-x align-bottom",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "cell small-auto" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "form-field-companyname",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("tours.companyname"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.searchActive
                                        ? _c("v-customer-select", {
                                            attrs: {
                                              "selected-customers":
                                                _vm.object.search_companies,
                                            },
                                            on: {
                                              "change-customers": function (
                                                $event
                                              ) {
                                                return _vm.onChangeCustomers(
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cell small-auto medium-3 u-extra-small-margin--top",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button",
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.addCustomersFromSearch.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("tours.company.add"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "u-fade" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.step2Active,
                              expression: "step2Active",
                            },
                          ],
                        },
                        [
                          _c("div", { staticClass: "box" }, [
                            _c("div", { staticClass: "grid-x grid-margin-x" }, [
                              _c("div", { staticClass: "cell medium-1" }, [
                                _c("div", { staticClass: "c-circle-label" }, [
                                  _c(
                                    "span",
                                    { staticClass: "c-circle-label__text" },
                                    [_vm._v("2")]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cell medium-11" },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "u-extra-small-margin--bottom",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("tours.headline.projectsearch")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-accordion", [
                                    _c(
                                      "div",
                                      { staticClass: "grid-x grid-margin-x" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cell small-auto medium-2",
                                          },
                                          [
                                            _c("h3", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("tours.qm.max.open")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cell small-auto medium-3",
                                          },
                                          [
                                            _vm.search_error_qm
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "u-error text-center u-extra-small-margin--bottom",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tours.error.search.qm"
                                                          )
                                                        ) +
                                                        "\n                              "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group form-group--row u-no-margin--bottom",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "u-no-margin--bottom text-right",
                                                    attrs: {
                                                      for: "form-field-qmmin",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("search.from")
                                                      ) + " "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.object.search_minqm,
                                                      expression:
                                                        "object.search_minqm",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control form-control--small",
                                                  attrs: {
                                                    type: "number",
                                                    inputmode: "decimal",
                                                    id: "form-field-qmmin",
                                                    name: "qmmin",
                                                    placeholder: "qm",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.object.search_minqm,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.object,
                                                        "search_minqm",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "u-no-margin--bottom text-right",
                                                    attrs: {
                                                      for: "form-field-qmmax",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("search.till")
                                                      ) + " "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.object.search_maxqm,
                                                      expression:
                                                        "object.search_maxqm",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control form-control--small",
                                                  attrs: {
                                                    type: "number",
                                                    inputmode: "decimal",
                                                    id: "form-field-qmmax",
                                                    name: "qmmax",
                                                    placeholder: "qm",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.object.search_maxqm,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.object,
                                                        "search_maxqm",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cell small-auto" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "loading-wrapper",
                                                class: {
                                                  "is-loading": _vm.isLoading,
                                                },
                                              },
                                              [
                                                _vm.isLoading
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "loading-message",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "results_loading"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.object.search_companies
                                                  .length == 0
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "no_results_found"
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.object.search_companies,
                                                  function (company, index) {
                                                    return _c(
                                                      "section",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "c-tourplan-company",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-tourplan-company__heading-select form-group form-group--check",
                                                          },
                                                          [
                                                            _c("label", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .projectSearchItems
                                                                        .companies_managers,
                                                                    expression:
                                                                      "projectSearchItems.companies_managers",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "checkbox",
                                                                  name: "companies_managers[]",
                                                                },
                                                                domProps: {
                                                                  value: String(
                                                                    company.id
                                                                  ),
                                                                  checked:
                                                                    Array.isArray(
                                                                      _vm
                                                                        .projectSearchItems
                                                                        .companies_managers
                                                                    )
                                                                      ? _vm._i(
                                                                          _vm
                                                                            .projectSearchItems
                                                                            .companies_managers,
                                                                          String(
                                                                            company.id
                                                                          )
                                                                        ) > -1
                                                                      : _vm
                                                                          .projectSearchItems
                                                                          .companies_managers,
                                                                },
                                                                on: {
                                                                  change: [
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          _vm
                                                                            .projectSearchItems
                                                                            .companies_managers,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c =
                                                                          $$el.checked
                                                                            ? true
                                                                            : false
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            String(
                                                                              company.id
                                                                            ),
                                                                          $$i =
                                                                            _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            _vm.$set(
                                                                              _vm.projectSearchItems,
                                                                              "companies_managers",
                                                                              $$a.concat(
                                                                                [
                                                                                  $$v,
                                                                                ]
                                                                              )
                                                                            )
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            _vm.$set(
                                                                              _vm.projectSearchItems,
                                                                              "companies_managers",
                                                                              $$a
                                                                                .slice(
                                                                                  0,
                                                                                  $$i
                                                                                )
                                                                                .concat(
                                                                                  $$a.slice(
                                                                                    $$i +
                                                                                      1
                                                                                  )
                                                                                )
                                                                            )
                                                                        }
                                                                      } else {
                                                                        _vm.$set(
                                                                          _vm.projectSearchItems,
                                                                          "companies_managers",
                                                                          $$c
                                                                        )
                                                                      }
                                                                    },
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onCheckCompanyManager(
                                                                        company.id
                                                                      )
                                                                    },
                                                                  ],
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c("i"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "c-tourplan-company__heading u-no-margin--bottom",
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        company.text
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        company.managers
                                                          .length > 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-tourplan-company__manager-results",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-accordion-project-managers",
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot: "buttonlabel",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "c-tourplan-company__manager-heading u-extra-small-margin--bottom",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "strong",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "search.pm"
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot: "content",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "ul",
                                                                          {
                                                                            staticClass:
                                                                              "c-tourplan-company__manager-select-list",
                                                                          },
                                                                          _vm._l(
                                                                            company.managers,
                                                                            function (
                                                                              manager,
                                                                              index
                                                                            ) {
                                                                              return _c(
                                                                                "li",
                                                                                {
                                                                                  key: index,
                                                                                  staticClass:
                                                                                    "u-extra-small-margin--bottom form-group form-group--check",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "label",
                                                                                    [
                                                                                      _c(
                                                                                        "input",
                                                                                        {
                                                                                          directives:
                                                                                            [
                                                                                              {
                                                                                                name: "model",
                                                                                                rawName:
                                                                                                  "v-model",
                                                                                                value:
                                                                                                  _vm
                                                                                                    .projectSearchItems
                                                                                                    .companies_managers,
                                                                                                expression:
                                                                                                  "projectSearchItems.companies_managers",
                                                                                              },
                                                                                            ],
                                                                                          attrs:
                                                                                            {
                                                                                              type: "checkbox",
                                                                                              name: "companies_managers[]",
                                                                                            },
                                                                                          domProps:
                                                                                            {
                                                                                              value:
                                                                                                company.id +
                                                                                                "-" +
                                                                                                manager.id,
                                                                                              checked:
                                                                                                Array.isArray(
                                                                                                  _vm
                                                                                                    .projectSearchItems
                                                                                                    .companies_managers
                                                                                                )
                                                                                                  ? _vm._i(
                                                                                                      _vm
                                                                                                        .projectSearchItems
                                                                                                        .companies_managers,
                                                                                                      company.id +
                                                                                                        "-" +
                                                                                                        manager.id
                                                                                                    ) >
                                                                                                    -1
                                                                                                  : _vm
                                                                                                      .projectSearchItems
                                                                                                      .companies_managers,
                                                                                            },
                                                                                          on: {
                                                                                            change:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                var $$a =
                                                                                                    _vm
                                                                                                      .projectSearchItems
                                                                                                      .companies_managers,
                                                                                                  $$el =
                                                                                                    $event.target,
                                                                                                  $$c =
                                                                                                    $$el.checked
                                                                                                      ? true
                                                                                                      : false
                                                                                                if (
                                                                                                  Array.isArray(
                                                                                                    $$a
                                                                                                  )
                                                                                                ) {
                                                                                                  var $$v =
                                                                                                      company.id +
                                                                                                      "-" +
                                                                                                      manager.id,
                                                                                                    $$i =
                                                                                                      _vm._i(
                                                                                                        $$a,
                                                                                                        $$v
                                                                                                      )
                                                                                                  if (
                                                                                                    $$el.checked
                                                                                                  ) {
                                                                                                    $$i <
                                                                                                      0 &&
                                                                                                      _vm.$set(
                                                                                                        _vm.projectSearchItems,
                                                                                                        "companies_managers",
                                                                                                        $$a.concat(
                                                                                                          [
                                                                                                            $$v,
                                                                                                          ]
                                                                                                        )
                                                                                                      )
                                                                                                  } else {
                                                                                                    $$i >
                                                                                                      -1 &&
                                                                                                      _vm.$set(
                                                                                                        _vm.projectSearchItems,
                                                                                                        "companies_managers",
                                                                                                        $$a
                                                                                                          .slice(
                                                                                                            0,
                                                                                                            $$i
                                                                                                          )
                                                                                                          .concat(
                                                                                                            $$a.slice(
                                                                                                              $$i +
                                                                                                                1
                                                                                                            )
                                                                                                          )
                                                                                                      )
                                                                                                  }
                                                                                                } else {
                                                                                                  _vm.$set(
                                                                                                    _vm.projectSearchItems,
                                                                                                    "companies_managers",
                                                                                                    $$c
                                                                                                  )
                                                                                                }
                                                                                              },
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "i"
                                                                                      ),
                                                                                      _vm._v(
                                                                                        "\n                                            " +
                                                                                          _vm._s(
                                                                                            manager.name
                                                                                          ) +
                                                                                          "\n                                          "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          0
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  2
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "grid-x text-right",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "cell auto" },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass: "button",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.projectSearch.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tours.button.projectsearch"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "u-fade" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.step3Active,
                              expression: "step3Active",
                            },
                          ],
                        },
                        [
                          _c("div", { staticClass: "box" }, [
                            _c("div", { staticClass: "grid-x grid-margin-x" }, [
                              _c("div", { staticClass: "cell medium-1" }, [
                                _c("div", { staticClass: "c-circle-label" }, [
                                  _c(
                                    "span",
                                    { staticClass: "c-circle-label__text" },
                                    [_vm._v("3")]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cell medium-11" },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "u-extra-small-margin--bottom",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "tours.headline.projectresults"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button outline secondary",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.toggleSearchHistory.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.showSearchHistory
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "tours.searchhistory.buttonlabel.live"
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "tours.searchhistory.buttonlabel.history"
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-accordion", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid-x grid-margin-x align-bottom",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cell small-auto" },
                                          [
                                            _c("v-table", {
                                              staticClass: "tourplan-table",
                                              attrs: {
                                                isLoading:
                                                  _vm.searchResultsTableLoading,
                                                columns:
                                                  _vm.searchResultsTableColumns,
                                                items:
                                                  _vm.projectSearchItems
                                                    .projectResults,
                                                showHeaderRow: true,
                                                showShowAll: false,
                                                useDetailRow: false,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "select",
                                                    fn: function ({ row }) {
                                                      return [
                                                        _c("label", [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.routeSelectedObjects,
                                                                expression:
                                                                  "routeSelectedObjects",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "checkbox",
                                                              name: "routeObjects[]",
                                                            },
                                                            domProps: {
                                                              value: row.id,
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.routeSelectedObjects
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.routeSelectedObjects,
                                                                      row.id
                                                                    ) > -1
                                                                  : _vm.routeSelectedObjects,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.routeSelectedObjects,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      row.id,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.routeSelectedObjects =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.routeSelectedObjects =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.routeSelectedObjects =
                                                                    $$c
                                                                }
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("i"),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "project_number",
                                                    fn: function ({ row }) {
                                                      return [
                                                        row.project_number
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "u-no-margin",
                                                              },
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    staticClass:
                                                                      "table__subtil-link",
                                                                    attrs: {
                                                                      to: {
                                                                        name: "customers-update-customer-project",
                                                                        params:
                                                                          {
                                                                            customer:
                                                                              row.customer_id,
                                                                            project:
                                                                              row.id,
                                                                          },
                                                                      },
                                                                      title:
                                                                        _vm.$t(
                                                                          "update"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        row.project_number
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !row.lat || !row.lon
                                                          ? _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  title: _vm.$t(
                                                                    "project.error.nogeolocation"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                !row.lat ||
                                                                !row.lon
                                                                  ? _c(
                                                                      "svg",
                                                                      {
                                                                        staticClass:
                                                                          "u-icon--geolocation-warning",
                                                                        attrs: {
                                                                          title:
                                                                            _vm.$t(
                                                                              "project.error.nogeolocation"
                                                                            ),
                                                                          role: "presentation",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "use",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "xlink:href":
                                                                                  "/dist/sprite.svg#icon-globe",
                                                                                href: "/dist/sprite.svg#icon-globe",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.projectHasRoute(row)
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "u-extra-small-margin--top",
                                                              },
                                                              _vm._l(
                                                                row.tour_routes,
                                                                function (
                                                                  route,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: index,
                                                                    },
                                                                    [
                                                                      route.tour_id !=
                                                                      _vm.object
                                                                        .id
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "callout alert u-text-center",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "router-link",
                                                                                {
                                                                                  staticClass:
                                                                                    "u-no-margin",
                                                                                  attrs:
                                                                                    {
                                                                                      to: {
                                                                                        name: "update-tour",
                                                                                        params:
                                                                                          {
                                                                                            tour: route.tour_id,
                                                                                          },
                                                                                      },
                                                                                      title:
                                                                                        _vm.$t(
                                                                                          "update"
                                                                                        ),
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      route.tour_number
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "small",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "(" +
                                                                                          _vm._s(
                                                                                            _vm._f(
                                                                                              "moment"
                                                                                            )(
                                                                                              route.tour_startdate,
                                                                                              "DD-MM-YYYY"
                                                                                            )
                                                                                          ) +
                                                                                          " - " +
                                                                                          _vm._s(
                                                                                            _vm._f(
                                                                                              "moment"
                                                                                            )(
                                                                                              route.tour_enddate,
                                                                                              "DD-MM-YYYY"
                                                                                            )
                                                                                          ) +
                                                                                          ")"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.projectHasWeekPlanEntries(
                                                          row
                                                        )
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "u-extra-small-margin--top u-extra-small-margin--bottom u-text-center",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "Wochenplan Einträge:"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  row.weekplan_entries,
                                                                  function (
                                                                    entry,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "callout alert u-text-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "router-link",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                title:
                                                                                  _vm.$t(
                                                                                    "update"
                                                                                  ),
                                                                                to: {
                                                                                  name: "update-day",
                                                                                  params:
                                                                                    {
                                                                                      date: _vm.formattedStartDate(
                                                                                        entry.startdate
                                                                                      ),
                                                                                      kolonne:
                                                                                        entry.kolonne,
                                                                                    },
                                                                                },
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Kolonne: " +
                                                                                _vm._s(
                                                                                  entry.kolonne
                                                                                ) +
                                                                                "  "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "small",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "moment"
                                                                                    )(
                                                                                      entry.startdate,
                                                                                      "DD-MM-YYYY"
                                                                                    )
                                                                                  ) +
                                                                                    " - " +
                                                                                    _vm._s(
                                                                                      _vm._f(
                                                                                        "moment"
                                                                                      )(
                                                                                        entry.enddate,
                                                                                        "DD-MM-YYYY"
                                                                                      )
                                                                                    )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  }
                                                                ),
                                                              ],
                                                              2
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "bauleiter",
                                                    fn: function ({ row }) {
                                                      return [
                                                        row.account
                                                          ? _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.account
                                                                    .profile
                                                                    .firstname
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    row.account
                                                                      .profile
                                                                      .lastname
                                                                  )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "company_name",
                                                    fn: function ({ row }) {
                                                      return [
                                                        row.customer
                                                          ? _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.customer
                                                                    .company_name
                                                                )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "address",
                                                    fn: function ({ row }) {
                                                      return [
                                                        row.address
                                                          ? _c("p", [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.address
                                                                      .zipcode
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      row
                                                                        .address
                                                                        .city
                                                                    )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                                  " +
                                                                  _vm._s(
                                                                    row.address
                                                                      .street
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    row.address
                                                                      .housenumber
                                                                  ) +
                                                                  "\n                                "
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "layers",
                                                    fn: function ({ row }) {
                                                      return row.layers
                                                        ? _vm._l(
                                                            row.layers,
                                                            function (
                                                              layer,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "p",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "u-extra-small-margin--bottom",
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        layer.subtype
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        : undefined
                                                    },
                                                  },
                                                  {
                                                    key: "openqm",
                                                    fn: function ({ row }) {
                                                      return row.stats
                                                        ? [
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.stats.qm
                                                                    .open
                                                                ) +
                                                                  " / " +
                                                                  _vm._s(
                                                                    row.stats.qm
                                                                      .total
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        : undefined
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "grid-x" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cell small-12 text-right",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("sum.openqm")
                                                          ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm.resultsOpenQM
                                                            )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "grid-x" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cell auto text-left",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button outline secondary",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openSingleProjectSearch.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tours.button.open.projectsearch"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button outline secondary",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.clearProjectSearchResults.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tours.button.delete.projectsearch"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cell auto text-right",
                                                  },
                                                  [
                                                    _vm.addingToTourPlan
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "loading-wrapper is-loading",
                                                            staticStyle: {
                                                              "margin-right":
                                                                "40px",
                                                            },
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "loading-message",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass: "button",
                                                        attrs: {
                                                          disabled:
                                                            _vm
                                                              .routeSelectedObjects
                                                              .length === 0,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.addProjectsToTourplan()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tours.button.addtourplan"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "cell auto" },
                    [
                      _c(
                        "h2",
                        { staticClass: "u-extra-small-margin--bottom" },
                        [_vm._v("Routeplanung")]
                      ),
                      _vm._v(" "),
                      _c("v-route-planner", {
                        ref: "routeplanner",
                        attrs: {
                          resize: !_vm.isLoading,
                          addresses: _vm.object.routes,
                          removeAddresses: _vm.removeAddresses,
                          startCity: _vm.object.start_city,
                          startAddress: _vm.object.start_address,
                          startZipcode: _vm.object.start_zipcode,
                          startLat: _vm.object.start_lat,
                          startLon: _vm.object.start_lon,
                          endCity: _vm.object.end_city,
                          endAddress: _vm.object.end_address,
                          endZipcode: _vm.object.end_zipcode,
                          endLat: _vm.object.end_lat,
                          endLon: _vm.object.end_lon,
                        },
                        on: {
                          onAddressError: _vm.handleAddressError,
                          onCalculateRouteError: _vm.onCalculateRouteError,
                          onAddressUpdate: _vm.handleAddressUpdate,
                          onEndPointError: _vm.handleEndpointError,
                          onCalculateRoute: _vm.getOptimizedRoute,
                          onEndpointUpdate: _vm.setEndpoints,
                          onOptimizingStateChange: function ($event) {
                            _vm.routeOptimizing = $event
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "section",
                        {
                          staticClass:
                            "c-routeplanner u-extra-large-margin--top",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "grid-x grid-margin-x align-bottom",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "cell small-auto medium-6" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "grid-x grid-margin-x" },
                                    [
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "p",
                                          { staticClass: "h4 u-no-margin" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("tours.startpoint"))
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "grid-x grid-margin-x" },
                                    [
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                attrs: { for: "start_zipcode" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("form.zipcode")
                                                  ) + "*"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.object.start_zipcode,
                                                  expression:
                                                    "object.start_zipcode",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control--small",
                                              attrs: {
                                                type: "text",
                                                name: "start_zipcode",
                                                id: "start_zipcode",
                                              },
                                              domProps: {
                                                value: _vm.object.start_zipcode,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.object,
                                                    "start_zipcode",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                attrs: { for: "start_address" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("form.street"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.object.start_address,
                                                  expression:
                                                    "object.start_address",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control--small",
                                              attrs: {
                                                type: "text",
                                                name: "start_address",
                                                id: "start_address",
                                              },
                                              domProps: {
                                                value: _vm.object.start_address,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.object,
                                                    "start_address",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "start_city" } },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("form.city"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.object.start_city,
                                                  expression:
                                                    "object.start_city",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control--small",
                                              attrs: {
                                                type: "text",
                                                name: "start_city",
                                                id: "start_city",
                                              },
                                              domProps: {
                                                value: _vm.object.start_city,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.object,
                                                    "start_city",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cell small-auto medium-6" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "grid-x grid-margin-x" },
                                    [
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "p",
                                          { staticClass: "h4 u-no-margin" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("tours.endpoint"))
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "grid-x grid-margin-x" },
                                    [
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "end_zipcode" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("form.zipcode")
                                                  ) + "*"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.object.end_zipcode,
                                                  expression:
                                                    "object.end_zipcode",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control--small",
                                              attrs: {
                                                type: "text",
                                                name: "end_zipcode",
                                                id: "end_zipcode",
                                              },
                                              domProps: {
                                                value: _vm.object.end_zipcode,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.object,
                                                    "end_zipcode",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "end_address" } },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("form.street"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.object.end_address,
                                                  expression:
                                                    "object.end_address",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control--small",
                                              attrs: {
                                                type: "text",
                                                name: "end_address",
                                                id: "end_address",
                                              },
                                              domProps: {
                                                value: _vm.object.end_address,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.object,
                                                    "end_address",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "start_city" } },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("form.city"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.object.end_city,
                                                  expression: "object.end_city",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control--small",
                                              attrs: {
                                                type: "text",
                                                name: "end_city",
                                                id: "end_city",
                                              },
                                              domProps: {
                                                value: _vm.object.end_city,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.object,
                                                    "end_city",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cell small-auto medium-2" },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        attrs: {
                                          disabled: _vm.routeOptimizing,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.requestOptimizedRoute()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("tours.button.optimizeroute")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          this.object.route_optimized === false
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "grid-x grid-margin-x align-center",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "callout alert small" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "tours.route_is_not_optimized"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-table", {
                        staticClass: "c-tourplan-table",
                        attrs: {
                          isLoading: _vm.tourplanResultsTableLoading,
                          columns: _vm.tourplanResultsTableColumns,
                          items: _vm.tourplanResultsTableItems,
                          showHeaderRow: true,
                          showShowAll: false,
                          useDetailRow: false,
                          reloadTable: _vm.tourplanResultsReloadTable,
                          rowClass: (row, index) =>
                            row.has_error === true ? "row-error" : "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "delete",
                              fn: function ({ row }) {
                                return [
                                  _c("label", { staticClass: "text-center" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.tourplanResultsTableItemsSelected,
                                          expression:
                                            "tourplanResultsTableItemsSelected",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        name: "tour_routes_selected[]",
                                        disabled: row.has_error,
                                      },
                                      domProps: {
                                        value: row.uid,
                                        checked: Array.isArray(
                                          _vm.tourplanResultsTableItemsSelected
                                        )
                                          ? _vm._i(
                                              _vm.tourplanResultsTableItemsSelected,
                                              row.uid
                                            ) > -1
                                          : _vm.tourplanResultsTableItemsSelected,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a =
                                                _vm.tourplanResultsTableItemsSelected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = row.uid,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.tourplanResultsTableItemsSelected =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.tourplanResultsTableItemsSelected =
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                              }
                                            } else {
                                              _vm.tourplanResultsTableItemsSelected =
                                                $$c
                                            }
                                          },
                                          _vm.onCheckTourplanItems,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("i"),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "index",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "c-tourplan-table__index",
                                      attrs: { "data-uid": row.uid },
                                    },
                                    [_vm._v(_vm._s(row.sort_order))]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "project_number",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "p",
                                    { staticClass: "u-no-margin" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "table__subtil-link",
                                          attrs: {
                                            to: {
                                              name: "customers-update-customer-project",
                                              params: {
                                                customer:
                                                  row.project.customer_id,
                                                project: row.project.id,
                                              },
                                            },
                                            title: _vm.$t("update"),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(row.project.project_number)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "company_name",
                              fn: function ({ row }) {
                                return [
                                  row.project && row.project.customer
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "u-no-margin c-tourplan-table__company-name",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              row.project.customer.company_name
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "address",
                              fn: function ({ row }) {
                                return row.address
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "u-extra-small-margin--bottom",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(row.address.zipcode) +
                                                " " +
                                                _vm._s(row.address.city)
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      row.distance
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.$t("tours.distance")) +
                                                ": " +
                                                _vm._s(row.distance) +
                                                " KM"
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.has_error
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "callout alert u-text-center",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tours.error.nogeocode"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : undefined
                              },
                            },
                            {
                              key: "comment",
                              fn: function ({ row }) {
                                return [
                                  row.project.site_comments
                                    ? _c("strong", [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(row.project.site_comments)
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "tok",
                              fn: function ({ row }) {
                                return [
                                  row.project.layer_tok
                                    ? _c("p", [_vm._v(_vm._s(_vm.$t("yes")))])
                                    : _c(
                                        "strong",
                                        { staticClass: "u-color--primary" },
                                        [_vm._v(_vm._s(_vm.$t("no")))]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "mixingplants",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "ul",
                                    _vm._l(
                                      row.mixingplants,
                                      function (mixingplant, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass:
                                              "u-extra-small-margin--bottom form-group form-group--check",
                                          },
                                          [
                                            _c("label", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.projectSelectedMixingplants,
                                                    expression:
                                                      "projectSelectedMixingplants",
                                                  },
                                                ],
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  value:
                                                    row.uid +
                                                    "_" +
                                                    mixingplant.id,
                                                  checked: Array.isArray(
                                                    _vm.projectSelectedMixingplants
                                                  )
                                                    ? _vm._i(
                                                        _vm.projectSelectedMixingplants,
                                                        row.uid +
                                                          "_" +
                                                          mixingplant.id
                                                      ) > -1
                                                    : _vm.projectSelectedMixingplants,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.projectSelectedMixingplants,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v =
                                                          row.uid +
                                                          "_" +
                                                          mixingplant.id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.projectSelectedMixingplants =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.projectSelectedMixingplants =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.projectSelectedMixingplants =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("i"),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _c("em", [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        parseFloat(
                                                          mixingplant.distance
                                                        ).toFixed(2)
                                                      ) +
                                                      " KM)"
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "u-no-margin u-extra-small-margin--bottom",
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "c-ranking",
                                                  class: _vm.rankingClass(
                                                    mixingplant.ranking
                                                  ),
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$helpers.limitString(
                                                        mixingplant.name,
                                                        45,
                                                        "..."
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "u-no-margin" },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      mixingplant.address
                                                        .zipcode
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        mixingplant.address.city
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              },
                            },
                            {
                              key: "media",
                              fn: function ({ row }) {
                                return [
                                  row.project.uploads.length >= 1
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "button button--action button--action--files button--small",
                                          attrs: {
                                            to: {
                                              name: "customers-view-customer-project-media",
                                              params: {
                                                customer:
                                                  row.project.customer_id,
                                                project: row.project.id,
                                              },
                                            },
                                            title: _vm.$t("media"),
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("media")))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("v-project-search-modal", {
        attrs: {
          isVisible: _vm.projectSearchModal.isVisible,
          currentSearchResults: _vm.projectSearchItems.projectResults,
        },
        on: { addProject: _vm.addProjectFromModal },
        model: {
          value: _vm.projectSearchModal.isVisible,
          callback: function ($$v) {
            _vm.$set(_vm.projectSearchModal, "isVisible", $$v)
          },
          expression: "projectSearchModal.isVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }